import { render, staticRenderFns } from "./TaskPostSelect.vue?vue&type=template&id=d0603408&scoped=true&"
import script from "./TaskPostSelect.vue?vue&type=script&lang=js&"
export * from "./TaskPostSelect.vue?vue&type=script&lang=js&"
import style0 from "./TaskPostSelect.vue?vue&type=style&index=0&id=d0603408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0603408",
  null
  
)

export default component.exports